// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1819": "671ccb9e130d","6638": "a7c322f609c8","6863": "454c9f289029","7658": "3505e50fd8f4","8357": "dd422574e14d","9603": "39e3b49b9460",}[chunkId] + ".css"
}